import { LocalStorage } from "quasar";
import { cloneDeep } from "lodash";

const STATE = {
  initialized: false,
  dark: LocalStorage.has("dark") ? LocalStorage.getItem("dark") : "auto",
  absoluteTime: LocalStorage.getItem("absoluteTime") || false,
  expandNav: LocalStorage.getItem("expandNav") || false,
  showMessages: LocalStorage.getItem("showMessages") || false,
  changelogLastSeenVersion:
    LocalStorage.getItem("changelogLastSeenVersion") || null,
  // Transient (session-only) anchor version used by the What's New dialog to
  // decide which releases are "new". Captured when the dialog is opened, BEFORE
  // marking the changelog seen, so remounts of the dialog don't lose the
  // comparison point. Intentionally not persisted to LocalStorage.
  changelogBaselineVersion: null,

  messagesProjectID: LocalStorage.getItem("messagesProjectID") || null,
  scrollToMessageID: null,
  // A topic for the messenger to select (just created from its topic bar)
  selectTopicID: null,
  // A reply for the messenger to start, `{ messageID, all }` (Task View's
  // Reply / Reply all), once it has the message
  startReply: null,
  allWidgetsExpanded: null, // null = no change, true = expand all, false = collapse all
  accounts: {},
  acks: {},
  balances: {},
  bills: {},
  claims: {},
  commission: {},
  companies: {},
  contacts: {},
  contactSaveListener: null,
  pendingContactSelection: null,
  pendingAddressSelection: null,
  creditMemos: {},
  ignoredDuplicatePairs: [],
  customerInvoices: {},
  customerProjectItems: {},
  customerProjects: {},
  customerQuoteResponses: {},
  customerQuotes: {},
  customerServiceIssues: {},
  events: {},
  expenses: {},
  feedback: {},
  heldPayAdjustments: {},
  inventoryCountLines: {},
  inventoryCounts: {},
  inventoryItems: {},
  invoices: {},
  issues: {},
  leadTimes: {},
  listeners: {},
  vendorShipments: {},
  // Truck-scoped receiving listener's copy, kept apart from vendorShipments:
  // the pending listener REMOVEs a shipment the moment it is fully received.
  truckShipments: {},
  messages: {},
  miscItems: {},
  notificationCounts: { total: 0, undone: 0, unread: 0 },
  notifications: [],
  orders: {},
  otherAcks: {},
  packingSlips: {},
  paychecks: {},
  projectEmails: {},
  projectFiles: {},
  projects: {},
  quotes: {},
  receivingSessions: {},
  receivingScans: {},
  reminders: [],
  saleItems: {},
  saleLabors: {},
  sales: {},
  salesGames: {},
  salesLeads: {},
  salesTeams: {},
  samples: {},
  serviceIssues: {},
  serviceLeads: {},
  serviceWorkOrders: {},
  knowledgeBase: {},
  tasks: {},
  topics: {},
  transactions: {},
  unassignedReceiving: {},
  unmatchedEmails: {},
  user: null,
  users: {},
  vehicles: {},
  warehouseMaps: {},
  schedulingContext: null,
  pendingServiceQuoteIssueID: null,
  salesGoals: {},
  callLogs: {},
  mileageLogs: {},
  mileageRates: {},

  managerShares: {},
  payrollRecords: {},

  libraryFolders: {},
  libraryFiles: {},
  // The Library's name index chunks (actions/libraryIndex.js).
  libraryIndex: {},
  libraryActivity: {},
  // Files the Library is uploading right now (QUEUE_LIBRARY_UPLOADS): the
  // rows the Uploading card shows, kept here so they outlive the page.
  libraryUploads: [],
};

export const getDefaultState = () => {
  return cloneDeep(STATE);
};

export default function () {
  return getDefaultState();
}
